export const INVOICE_STATUS = [
  {
    value: 1,
    label: "Estimate",
    color: "#747d8c"
  },
  {
    value: 2,
    label: "Draft",
    color: "#747d8c"
  },
  {
    value: 3,
    label: "Sent",
    color: "black"
  },
  {
    value: 5,
    label: "Partial",
    color: "#23cba7"
  },
  {
    value: 4,
    label: "Paid",
    color: "#23cba7"
  },
  {
    value: 6,
    label: "Void",
    color: "#747d8c"
  },
];

